/**
 * @description 四舍五入保留小数
 * @param {Number} value 需要格式化的值
 * @param {Number} n 保留的小数位数
 * @returns {Number} 结果
 */
export function formatFloat(value, n) {
  if (!value) {
    return 0;
  }
  if (!n) {
    n = 0;
  }
  const powValue = Math.pow(10, n);
  const newV = Math.round(Number(value) * powValue) / powValue;
  return newV.toFixed(n);
}

/**
 * @description 格式化数字 逗号分隔
 * @param {Number, String} value 需要格式化的值 数字/字符串
 * @param {Number} n 保留n位小数
 * @returns {String} 结果
 */
export function formatWithCommas(value, n = 2) {
  const numberWithCommas = (x, n) => {
    const numX = Number(x).toFixed(n);
    const parts = numX.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };
  if ((!value && value != 0) || !/^-?[0-9,.]+%?$/.test(String(value))) {
    return "--";
  } else {
    const inValue = String(value);
    const hasPercent = inValue.includes("%");
    let outValue = inValue.replace("%", "");
    outValue = numberWithCommas(outValue, n);
    if (hasPercent) {
      outValue += "%";
    }
    return outValue;
  }
}
